<style lang="less" scoped>
.title-div {
  font-weight: 600;
  margin: 20px 10px 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}

.header-dropdown {
  color: #4182EB;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px 10px 20px;

  .header-container-name {
    height: 30px;
    line-height: 30px;
  }
}

.pileItem-div {
  font-weight: 600;
  margin: 0 10px !important;
  font-size: 20px;
  // flex-grow: 1;
  color: #000;
  // height: 30px;
}

.el-form-item {
  margin-bottom: 0;
  margin-left: 10px;
}

/deep/.el-form-item__label {
  text-align: left !important;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #8F9BB3;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    // width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    min-width: 160px;
    // text-align: right;
  }
}

/deep/ .avatar-uploader .el-upload {
  width: 164px;
  height: 164px;
  line-height: 164px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 164px;
  height: 164px;
  line-height: 164px;
  text-align: center;
}

/deep/ .avatar {
  width: 164px;
  height: 164px;
  display: block;
}
</style>

<template>
  <div class="detail-content-div">
    <div class="title-div">
      共享开关信息
      <!-- <el-dropdown @command="handleCommand">
        <div class="flex-r header-dropdown">
          <p class="header-container-name">{{ queryInfo.deviceCode }}</p>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="i in pileList" :key="i.pileType" :command="i.pileType">
            {{ i.pileType }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <el-form :model="pileInfo" ref="formForm" label-width="120px" class="detail-form">
      <el-row :gutter="20">
        <el-col :span="24"> <span class="pileItem-div">基础信息</span> </el-col>
        <el-col :span="8">
          <el-form-item label="设备编号">
            <el-input type="text" size="small" disabled v-model="pileInfo.deviceCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备名称">
            <el-input type="text" size="small" disabled v-model="pileInfo.shareStationName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备型号">
            <el-input type="text" size="small" disabled v-model="pileInfo.pileTypeName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否开通共享">
            <el-input type="text" size="small" disabled v-model="pileInfo.shareActiveName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="当前共享状态">
            <el-input type="text" size="small" disabled v-model="pileInfo.typeName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="共享开关实时状态" label-width="150px">
            <el-input type="text" size="small" disabled v-model="pileInfo.shareLocalStatusName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="共享列表状态">
            <el-input type="text" size="small" disabled v-model="pileInfo.shareListLocalStatus" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="绑定渠道">
            <el-input type="text" size="small" disabled v-model="pileInfo.bindChannelName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所属用户">
            <el-input type="text" size="small" disabled v-model="pileInfo.custMobile" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="绑定时间">
            <el-input type="text" size="small" disabled v-model="pileInfo.bindTime" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="最近订单开始时间" label-width="150px">
            <el-input type="text" size="small" disabled v-model="pileInfo.lastOrderTime" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="剩余补贴发放时间" label-width="150px">
            <el-input type="text" size="small" disabled v-model="pileInfo.endDisbursementTime" />
          </el-form-item>
        </el-col>
        <el-col :span="24"><span class="pileItem-div">参数信息</span></el-col>
        <el-col :span="8">
          <el-form-item label="厂家/厂商代码">
            <el-input type="text" size="small" disabled v-model="pileInfo.manufactureCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="绑定方式">
            <!-- <el-input type="text" size="small" disabled v-model="pileInfo.businessBelongName" /> -->
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联网方式">
            <el-input type="text" size="small" disabled v-model="pileInfo.onlineConnectType" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电流采集">
            <el-input type="text" size="small" disabled v-model="pileInfo.currentValueCollect" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电压采集">
            <el-input type="text" size="small" disabled v-model="pileInfo.voltageValueCollect" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电量采集">
            <el-input type="text" size="small" disabled v-model="pileInfo.powerDataCollect" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="温度采集">
            <el-input type="text" size="small" disabled v-model="pileInfo.tempDataCollect" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="保护功能">
            <el-input type="text" size="small" disabled v-model="pileInfo.protectFunction" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="指示灯">
            <el-input type="text" size="small" disabled v-model="pileInfo.signalLight" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="支持协议">
            <el-input type="text" size="small" disabled v-model="pileInfo.connectProtocol" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="设备图片">
            <!-- 默认图片：只显示，可点击放大，不可上传 -->
            <el-image v-if="isDefaultImage" :src="deviceImageUrl" :preview-src-list="[deviceImageUrl]" fit="cover"
              style="width: 164px; height: 164px; cursor: pointer; border: 1px dashed #d9d9d9; border-radius: 6px;"></el-image>
            <!-- 有图片URL：可上传，可点击放大 -->
            <el-upload v-else class="avatar-uploader" action="#" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <el-image :src="deviceImageUrl" :preview-src-list="[deviceImageUrl]" fit="cover" class="avatar"
                style="width: 164px; height: 164px; cursor: pointer;"></el-image>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 默认值设置
      queryInfo: {
        deviceCode: '',
      },
      pileList: [],
      pileInfo: {},
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false
    }
  },
  computed: {
    deviceImageUrl() {
      return this.pileInfo.typeImgFilePathUrl || 'https://zd-app-data.oss-cn-shanghai.aliyuncs.com/static/kaiguanshebei.png'
    },
    isDefaultImage() {
      return !this.pileInfo.typeImgFilePathUrl
    }
  },
  methods: {
    init() {
      let _ = this;
      const list = _.$store.state.pileObj || null
      if (list) {
        _.queryInfo.deviceCode = list.deviceCode || ''
        _.getFormInfo()
      }
    },
    // 获取详情-充电桩
    getFormInfo() {
      let _ = this;
      _.$H.post(_, _.$A.digitization.getShareDeviceInfo, _.queryInfo).then((res) => {
        _.pileInfo = res.data.data || {}
      })
    },
    handleCommand(val) {
      let _ = this;
      _.custInfo.pileCode = val;
      _.getFormInfo()
    },

    handleAvatarSuccess(response, uploadFile) {
      imageUrl.value = URL.createObjectURL(uploadFile.raw)
    },

    beforeAvatarUpload(rawFile) {
      if (rawFile.type !== 'image/jpeg') {
        ElMessage.error('Avatar picture must be JPG format!')
        return false
      } else if (rawFile.size / 1024 / 1024 > 2) {
        ElMessage.error('Avatar picture size can not exceed 2MB!')
        return false
      }
      return true
    }
  },
  mounted() {
    this.init()
  },
}
</script>
